import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import IdDocAnimation from '../../../components/id-doc-animation';
import Loading from '../../../components/loading';
import RetryLimitExceeded from '../../../components/retry-limit-exceeded';
import Success from '../../../components/success';
type MobileProcessingViewProps = {
  mode: 'loading' | 'success';
  step: 'upload' | 'analyze';
  showSlowConnectionMessage: boolean;
  retryLimitExceeded: boolean;
  isMissingRequirements: boolean;
  onSuccess: () => void;
  onRetryLimitExceeded: () => void;
};
const MobileProcessingView = t0 => {
  const $ = _c(16);
  const {
    mode,
    step,
    showSlowConnectionMessage,
    retryLimitExceeded,
    isMissingRequirements,
    onSuccess,
    onRetryLimitExceeded
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.non-id-doc.pages.desktop-processing"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  if (isMissingRequirements) {
    let t2;
    if ($[1] !== t) {
      t2 = t(_temp);
      $[1] = t;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t2) {
      t3 = <div className="text-label-1 text-error text-center">{t2}</div>;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  if (retryLimitExceeded) {
    let t2;
    if ($[5] !== onRetryLimitExceeded) {
      t2 = <RetryLimitExceeded onRetryLimitExceeded={onRetryLimitExceeded} />;
      $[5] = onRetryLimitExceeded;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  let t2;
  if ($[7] !== showSlowConnectionMessage || $[8] !== step) {
    t2 = <Loading step={step} showSlowConnectionMessage={showSlowConnectionMessage} />;
    $[7] = showSlowConnectionMessage;
    $[8] = step;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== onSuccess) {
    t3 = <Success onComplete={onSuccess} />;
    $[10] = onSuccess;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== mode || $[13] !== t2 || $[14] !== t3) {
    t4 = <div className="flex flex-col items-center justify-center h-full min-h-[280px]"><IdDocAnimation loadingComponent={t2} successComponent={t3} mode={mode} hasNextSide={false} /></div>;
    $[12] = mode;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
export default MobileProcessingView;
function _temp($) {
  return $["missing-requirement-error"];
}